export default __webpack_public_path__ + "static/media/dxzg_logo.088c38c6.png";